var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarUnfill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64345 2.05484C6.78089 1.82091 7.11914 1.82091 7.25658 2.05484L8.49307 4.15946C8.68538 4.48679 9.00613 4.71847 9.37731 4.79815L11.7668 5.31114C12.0342 5.36854 12.1394 5.69368 11.9563 5.89682L10.3352 7.69546C10.0788 7.97998 9.95469 8.35969 9.99361 8.74073L10.2394 11.1477C10.2671 11.4184 9.99275 11.6186 9.74337 11.5097L7.49269 10.5264C7.1467 10.3752 6.75334 10.3752 6.40734 10.5264L4.15665 11.5097C3.90728 11.6186 3.63295 11.4184 3.6606 11.1477L3.90642 8.74073C3.94534 8.35969 3.82124 7.97997 3.56481 7.69546L1.94371 5.89682C1.76062 5.69368 1.86582 5.36854 2.13319 5.31114L4.52272 4.79815C4.8939 4.71847 5.21465 4.48679 5.40696 4.15946L6.64345 2.05484Z",
    stroke: "url(#paint0_linear_8502_47901)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8502_47901",
    x1: 6.95009,
    y1: 1.45562,
    x2: 6.95009,
    y2: 12.0084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarUnfill);
export default __webpack_public_path__ + "static/media/star-unfill.56006b41056056d6c8ffcee344db3174.svg";
export { ForwardRef as ReactComponent };